
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const CancunHomePage = lazy(() => import('../pages/cancun-home/page'));
const LibroReclamacionesPage = lazy(() => import('../pages/cancun-libro-reclamaciones/page'));
const CancunAdminLoginPage = lazy(() => import('../pages/cancun-admin/login/page'));
const CancunAdminDashboard = lazy(() => import('../pages/cancun-admin/CancunAdminDashboard'));
const CancunTerminosPage = lazy(() => import('../pages/cancun-legal/TerminosPage'));
const CancunPrivacidadPage = lazy(() => import('../pages/cancun-legal/PrivacidadPage'));
const CancunCookiesPage = lazy(() => import('../pages/cancun-legal/CookiesPage'));
const CancunReglamentoPage = lazy(() => import('../pages/cancun-legal/ReglamentoPage'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <CancunHomePage />,
  },

  // --- admin ---
  {
    path: '/cancun-admin/login',
    element: <CancunAdminLoginPage />,
  },
  {
    path: '/cancun-admin',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/dashboard',
    element: <CancunAdminDashboard />,
  },
  // Tickets/Entradas desconectado por ahora — ver CancunAdminDashboard.tsx
  // {
  //   path: '/cancun-admin/tickets',
  //   element: <CancunAdminDashboard />,
  // },
  {
    path: '/cancun-admin/features',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/galeria',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/testimonios',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/faqs',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/popup',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/config',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/reservas',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/reclamaciones',
    element: <CancunAdminDashboard />,
  },
  {
    path: '/cancun-admin/usuarios',
    element: <CancunAdminDashboard />,
  },

  // --- legales (mismo RUC, marca propia) ---
  {
    path: '/terminos',
    element: <CancunTerminosPage />,
  },
  {
    path: '/privacidad',
    element: <CancunPrivacidadPage />,
  },
  {
    path: '/cookies',
    element: <CancunCookiesPage />,
  },
  {
    path: '/reglamento-interno',
    element: <CancunReglamentoPage />,
  },

  {
    path: '/libro-reclamaciones',
    element: <LibroReclamacionesPage />,
  },

  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
